import * as React from 'react'
import { I18n } from 'react-redux-i18n'

import './styles.scss'
import ModalWrapper from './ModalWrapper'
import { Button, SelectWithLabel } from 'components/Form'
import CopyToClipboard from 'react-copy-to-clipboard'
import { iconText, staticFloating, sizeButton } from 'constants/channels'
import { getBotWidget, getBotWidgetFloating, getChatWebScript } from 'utils/helpers'

const ButtonAndLink = (props) => {
  const { data, company } = props
  const [ link, setLink ] = React.useState(null)
  const [ channel, setChannel ] = React.useState(null)

  const [ iconTextOptions ] = React.useState(iconText.map(it=> ({ ...it, label: I18n.t(it.label) })))
  const [ iconTextValue, setIconTextValue ] = React.useState([iconTextOptions[0]])
  const [ iconTextValue2, setIconTextValue2 ] = React.useState([iconTextOptions[0]])
  const [ iconSizeButtonOptions ] = React.useState(sizeButton.map(it=> ({ ...it, label: I18n.t(it.label) })))
  const [ iconSizeButtonValue, setIconSizeButtonValue ] = React.useState([iconSizeButtonOptions[2]])
  const [ staticFloatingOptions ] = React.useState(staticFloating.map(it=> ({ ...it, label:I18n.t(it.label) })))
  const [ staticFloatingValue, setStaticFloatingValue ] = React.useState([staticFloatingOptions[0]])
  const [ widgetText, setWidgetText ] = React.useState(null)
  const [ widgetIcon, setWidgetIcon ] = React.useState(null)
  const [ widgetTextFloating, setWidgetTextFloating ] = React.useState(null)
  const [ widgetIconFloating, setWidgetIconFloating ] = React.useState(null)
  const [ widgetTextEmail, setWidgetTextEmail ] = React.useState(null)
  const [ widgetIconEmail, setWidgetIconEmail ] = React.useState(null)
  const [email, setEmail] = React.useState(null)
  const [buttonWeb, setButtonWeb] = React.useState(null)

  React.useEffect(()=> {
    setLink(data.link)
    setChannel(data.channel)

    let size = iconSizeButtonValue[0].value

    setWidgetText(getBotWidget(data.channel, company))
    setWidgetIcon(getBotWidget(data.channel, company, true))
    setWidgetTextEmail(getBotWidget(data.channel, company, false, '', true))
    setWidgetIconEmail(getBotWidget(data.channel, company, true, size, true))
    setWidgetTextFloating(getBotWidgetFloating(data.channel, company))
    setWidgetIconFloating(getBotWidgetFloating(data.channel, company, true))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  React.useEffect(()=> {
    if (widgetText && widgetIcon) {
      setButtonWeb(buttonPreview2(iconTextValue2[0].value, staticFloatingValue[0].value))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [widgetText, widgetIcon])

  React.useEffect(()=> {
    setButtonWeb(buttonPreview2(iconTextValue2[0].value, staticFloatingValue[0].value))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [iconTextValue2, staticFloatingValue])

  const onChange = (value, type) => {
    if (type === 'iconText') {
      setIconTextValue(value)
    }
    if (type === 'iconText2') {
      setIconTextValue2(value)
    }
    else if (type === 'staticFloating') {
      setStaticFloatingValue(value)
    }
  }

  const onChangeSize = (value) => {
    const size = value[0].value
    setWidgetTextEmail(getBotWidget(channel, company, false, '', true))
    setWidgetIconEmail(getBotWidget(channel, company, true, size, true))

    setIconSizeButtonValue(value)
  }

  const copyToEmail = (item) => {
    const element = item
    const selection = window.getSelection()
    const range = document.createRange()
    range.selectNodeContents(element)
    selection.removeAllRanges()
    selection.addRange(range)

    try {
      return document.execCommand('copy')
    } catch (ex) {
      return false
    }
  }

  const buttonPreview = (type) => {
    if (!type) return null

    if (type === 'icon') {
      return widgetIconEmail
    }

    return widgetTextEmail
  }

  const buttonPreview2 = (type1, type2 = 'static') => {
    if (type1 === 'icon') {
      if (type2 === 'static') {
        return widgetIcon
      }
      else {
        return (channel && channel.key === 'chatweb') ? getChatWebScript(channel) : widgetIconFloating
      }
    }
    else {
      if (type2 === 'static') {
        return widgetText
      }
      else {
        return widgetTextFloating
      }
    }
  }

  const body = (
    <div>
      { link &&
        <div className='link-to-bot'>
          <h2>{I18n.t('channels_link_to_bot')}</h2>
          <legend>{I18n.t('channels_link_to_bot_legend')}</legend>
          <div className='link-wrapper'>
            <span id={channel.key + 'link'}>{link}</span>
            <CopyToClipboard text={link}>
              <i className='fa fa-clone'/>
            </CopyToClipboard>
          </div>
        </div>
      }
      <div className='button-to-email'>
        <div>
          <h2>{I18n.t('channels_link_to_email')}</h2>
          <legend>{I18n.t('channels_link_to_email_legend')}</legend>
          <div>
            <SelectWithLabel
              name='iconText'
              key='iconText'
              options={iconTextOptions}
              multi={false}
              value={iconTextValue}
              selectedValues={iconTextValue}
              onChange={(value)=> onChange([value], 'iconText')}
              classNameWrapper='iconText-selector'
            />
          </div>
          {
            iconTextValue?.[0]?.value === 'icon'
              ? (
                <div style={{ marginTop: 10 }}>
                  <SelectWithLabel
                    name='sizeButton'
                    key='sizeButton'
                    options={iconSizeButtonOptions}
                    multi={false}
                    value={iconSizeButtonValue}
                    selectedValues={iconSizeButtonValue}
                    onChange={(value) => onChangeSize([value])}
                    classNameWrapper='sizeButton-selector'
                  />
                </div>
              ) : null
          }
          <div className='copy-email-button' onClick={()=> copyToEmail(email)}>
            <i className='fa fa-clone'/>
            <span>{I18n.t('channels_copy_to_email')}</span>
          </div>
        </div>
        <div className='preview'>
          <span>{I18n.t('dashboard_preview')}</span>
          <div ref={(node) => setEmail(node)} className='div-copy-email'>
            <div dangerouslySetInnerHTML={{ __html: buttonPreview(iconTextValue[0].value) }} />
          </div>
          <div>
            <div dangerouslySetInnerHTML={{ __html: buttonPreview(iconTextValue[0].value) }} />
          </div>
        </div>
      </div>

      <div className='button-to-web'>
        <div>
          <h2>{I18n.t('channels_link_to_web')}</h2>
          <legend>{I18n.t('channels_link_to_web_legend')}</legend>
          <div className='selectors-config'>
            <SelectWithLabel
              name='iconText2'
              key='iconText2'
              options={iconTextOptions}
              multi={false}
              value={iconTextValue2}
              selectedValues={iconTextValue2}
              onChange={(value)=>onChange([value], 'iconText2')}
              classNameWrapper='selectors'
            />
            <SelectWithLabel
              name='staticFloating'
              key='staticFloating'
              options={staticFloatingOptions}
              multi={false}
              value={staticFloatingValue}
              selectedValues={staticFloatingValue}
              onChange={(value)=>onChange([value], 'staticFloating')}
              classNameWrapper='selectors'
            />
          </div>

          <CopyToClipboard text={buttonWeb}>
            <div className='copy-email-button' >
              <i className='fa fa-clone'/>
              <span>{I18n.t('channels_copy_to_web')}</span>
            </div>
          </CopyToClipboard>
        </div>
        <div className='preview'>
          <span>{I18n.t('dashboard_preview')}</span>
          <div> <div dangerouslySetInnerHTML={{ __html: buttonPreview2(iconTextValue2[0].value) }} /></div>
        </div>
      </div>
      <Button value={I18n.t('dashboard_close')} secondary onClick={props.toggle}/>
    </div>
  )

  return (
    <ModalWrapper
      id={'modalButtonLink'}
      header={<h1>{I18n.t('channels_button_and_link')}</h1>}
      body={body}
      isOpen={props.isOpen}
      toggle={props.toggle}
      showClose={true}
    />
  )
}

export default ButtonAndLink